import { useI18n } from '@change-corgi/core-react/i18n';

type Props = {
	/** Changes on every successful copy, `null` when there is nothing to announce. */
	announcementKey: number | null;
};

/**
 * Screen-reader-only confirmation for a copy-link button. Render it as a sibling of the button, not inside it:
 * a live region nested in a focused control makes VoiceOver announce the change twice. The region stays mounted
 * (a live region must exist before its content changes) and re-keys its content on each copy, so repeat copies
 * are announced too. `output`'s implicit role is `status`.
 */
export const CopyLinkStatus = ({ announcementKey }: Props): React.JSX.Element => {
	const { translate } = useI18n();

	return (
		<output data-testid="copy-link-status" aria-live="polite" className="sr-only">
			{announcementKey !== null && (
				<span key={announcementKey}>{translate('corgi.petition_gamma.share.link_copied')}</span>
			)}
		</output>
	);
};
